import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

i18n
  .use(initReactI18next)
  .init({
    debug: true,
    fallbackLng: 'es',
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    // language resources
    resources: {
      es: {
        translation: {
          inicio_welcome: "Bienvenidos",
          inicio_dashboard: "Tablero Financiero",
          inicio_instructions_header: "Para comenzar selecciona una opción",
          inicio_instructions_op1: "Inicio de inversión",
          inicio_instructions_op2: "Estatus de inversión",
          inicio_instructions: "PleeZ acerque su brazalete al lector",
          inicio_imageUrbano: "Imagen_Urbano.png",
          inicio_cetesLogo: "",
          inicio_kidzaniaLogo: "",

          tipoInversion_title: "Selecciona tu",
          tipoInversion_subtitle: "Forma de inversión",
          tipoInversion_opt1: "Efectivo",
          tipoInversion_opt2: "Tarjeta",

          meta_title: "Elige una ",
          meta_title_bold: "Meta",
          meta_subtitle: "Escoge un producto de nuestra Tienda de Redención",
          meta_confirm: "Confirmar",

          resumen_title: "Estatus de ",
          resumen_title_bold: "Inversión",
          resumen_title_name: "Nombre",
          resumen_columna_folio: "Folio",
          resumen_columna_fecha: "Fecha",
          resumen_columna_inv_inicial: "Inversión inicial",
          resumen_columna_hora_inicio: "Hora de inicio",
          resumen_columna_hora_fin: "Hora de fin",
          resumen_columna_tiempo: "Tiempo de inversión",
          resumen_columna_inv_final: "Inversión Final",
          resumen_columna_finalizar: "Finalizar",

          registro_mainTitle: "Para iniciar la inversión",
          registro_subtitle: "por medio de tu cuenta de banco, proporciona los siguientes datos",
          registro_cardNumber: "Número de tarjeta",
          registro_name: "Nombre",
          registro_lastName: "Apellidos",
          registro_birthday: "Fecha de nacimiento",
          registro_cancel: "Cancelar",
          registro_search: "Buscar",
          registro_start: "Iniciar",

          summary_title: "BIENVENIDO",
          summary_hour: "Hora",
          summary_date: "Fecha",
          summary_objective: "Define un objetivo de ahorro",
          summary_startAmount: "Monto Inicial",
          summary_rate: "Tasa",
          summary_time: "Tiempo",
          summary_minutes: "Minutos",
          summary_investment: "Inversión",
          summary_amount: "Monto",
          summary_financial: "Estatus",
          summary_status: "Financiero",
          symmary_yieldText: "Rendimiento",
          summary_total: "Total",

          summary_summary: "Resumen de ",
          summary_operation: "Operación",
          summary_id: "Folio",
          summary_name: "Nombre",
          summary_investmentAmount: "Monto de inversión",
          summary_yield: "Tasa de rendimiento",
          summary_investmentStart: "Inicio de inversión",
          summary_investmentEnd: "Fin de inversión",
          summary_investmentTime: "Tiempo de inversión",
          summary_finalBalance: "Inversión final",
          summary_confirm: "Confirmar",
          summary_cancel: "Cancelar",

          detail_print_button: "Imprimir",
          detail_end_button: "Finalizar",

          end_title: "¡KongratZ kal!",
          end_subtitle: "Continúa invirtiendo paar alcanzar tu meta. ¡Z-U!.",
          end_button: "Ir al inicio",

          cms_name: "Nombre",
          cms_value: "Precio",
          cms_image: "Imagen",
          cms_save: "Guardar",
          cms_deleted: "Producto eliminado",
          cms_delete_error: "Error al eliminar producto",
          cms_saved: "Producto guardado",
          cms_save_error: "Error al guardar producto",
          cms_save: "Guardar",
          cms_delete: "Eliminar",
          cms_no_products: "No hay productos disponibles",
        }
      },
      en: {
        translation: {
          inicio_welcome: "Welcome",
          inicio_dashboard: "Financial Dashboard",
          inicio_instructions_header: "Please select an option to start",
          inicio_instructions_op1: "Start investment",
          inicio_instructions_op2: "Investment Status",
          inicio_instructions: "Please bring the bracelet close to the reader to start the investment process",
          inicio_imageUrbano: "Botones.png",
          inicio_cetesLogo: "",
          inicio_kidzaniaLogo: "",

          tipoInversion_title: "Selecciona tu",
          tipoInversion_subtitle: "Forma de inversión",
          tipoInversion_opt1: "Efectivo",
          tipoInversion_opt2: "Tarjeta",

          meta_title: "Choose a ",
          meta_title_bold: "Goal",
          meta_subtitle: "Pick a product from our store",
          meta_confirm: "Confirm",

          resumen_title: "Investment",
          resumen_title_bold: "Status",
          resumen_title_name: "Name:",
          resumen_columna_folio: "ID",
          resumen_columna_fecha: "Date",
          resumen_columna_inv_inicial: "Inicial amount",
          resumen_columna_hora_inicio: "Start time",
          resumen_columna_hora_fin: "End time",
          resumen_columna_tiempo: "Investment time",
          resumen_columna_inv_final: "Final amount",
          resumen_columna_finalizar: "End",

          registro_mainTitle: "To start the investemt",
          registro_subtitle: "from your bank account, please fill the fields",
          registro_cardNumber: "Card Number",
          registro_name: "Name",
          registro_lastName: "Last Name",
          registro_birthday: "Birthday",
          registro_cancel: "Cancel",
          registro_search: "Search",
          registro_start: "Start",

          summary_title: "WELCOME",
          summary_hour: "Hour",
          summary_date: "Date",
          summary_objective: "Set an objective",
          summary_startAmount: "Initial amount",
          summary_rate: "Rate",
          summary_time: "Time",
          summary_minutes: "Minutes",
          summary_investment: "INVESTMENT",
          summary_amount: "Amount",
          summary_financial: "Financial",
          summary_status: "Status",
          symmary_yieldText: "Yield",
          summary_total: "Total",

          summary_summary: "Operation",
          summary_operation: " Summary",
          summary_id: "ID",
          summary_name: "Name",
          summary_investmentAmount: "Investment Amount",
          summary_yield: "Investment Rate",
          summary_investmentStart: "Investment start date",
          summary_investmentEnd: "Investment end date",
          summary_investmentTime: "Total investment time",
          summary_finalBalance: "Investment balance",
          summary_confirm: "Confirm",
          summary_cancel: "Cancel",

          detail_print_button: "Print",
          detail_end_button: "End",

          end_title: "Investment Completed",
          end_subtitle: "Your investment has been successfully completed.",
          end_button: "Return to Dashboard",

          cms_name: "CMS",
          cms_value: "Value",
          cms_image: "Image",
          cms_save: "Save",
          cms_deleted: "Producto eliminado",
          cms_delete_error: "Error al eliminar producto",
          cms_saved: "Producto guardado",
          cms_save_error: "Error al guardar producto",
          cms_save: "Guardar",
          cms_delete: "Eliminar",
          cms_no_products: "No hay productos disponibles",
          
        }
      },
    }
  });

export default i18n;